module.exports = __webpack_public_path__ + "static/media/help_studies_map.bf5eee31.svg";